// extracted by mini-css-extract-plugin
export var itemsWrap = "MovingLogoBlock-module--itemsWrap--9AbhC";
export var items = "MovingLogoBlock-module--items--sZLZV";
export var item = "MovingLogoBlock-module--item--q43ss";
export var icon = "MovingLogoBlock-module--icon--qrZEw";
export var marquee = "MovingLogoBlock-module--marquee--RsNBu";
export var scroll = "MovingLogoBlock-module--scroll--7akF+";